[
  {
    "name": "Salesforce",
    "phrase": "Salesforce AI agent"
  },
  {
    "name": "HubSpot",
    "phrase": "HubSpot AI agent"
  },
  {
    "name": "Pipedrive",
    "phrase": "Pipedrive automation with AI"
  },
  {
    "name": "Attio",
    "phrase": "Attio AI"
  },
  {
    "name": "QuickBooks",
    "phrase": "QuickBooks AI agent"
  },
  {
    "name": "Xero",
    "phrase": "Xero AI"
  },
  {
    "name": "Jira",
    "phrase": "Automate Jira with AI"
  },
  {
    "name": "Linear",
    "phrase": "Linear automation with AI"
  },
  {
    "name": "Asana",
    "phrase": "Asana automation with AI"
  },
  {
    "name": "ClickUp",
    "phrase": "ClickUp automation with AI"
  },
  {
    "name": "Trello",
    "phrase": "Trello automation with AI"
  },
  {
    "name": "Airtable",
    "phrase": "Airtable automation with AI"
  },
  {
    "name": "Confluence",
    "phrase": "Confluence automation with AI"
  },
  {
    "name": "Intercom",
    "phrase": "Intercom AI agent"
  },
  {
    "name": "Pylon",
    "phrase": "Pylon AI"
  },
  {
    "name": "Amplitude",
    "phrase": "Amplitude AI agent"
  },
  {
    "name": "Mixpanel",
    "phrase": "Mixpanel AI"
  },
  {
    "name": "PostHog",
    "phrase": "PostHog AI"
  },
  {
    "name": "Supabase",
    "phrase": "Supabase AI"
  },
  {
    "name": "BigQuery",
    "phrase": "BigQuery AI"
  },
  {
    "name": "Sentry",
    "phrase": "Sentry AI"
  },
  {
    "name": "Datadog",
    "phrase": "Datadog workflow automation"
  },
  {
    "name": "Grafana",
    "phrase": "Grafana AI"
  },
  {
    "name": "New Relic",
    "phrase": "New Relic AI"
  },
  {
    "name": "Zoom",
    "phrase": "Zoom workflow automation"
  },
  {
    "name": "Granola",
    "phrase": "Granola AI"
  },
  {
    "name": "Fireflies",
    "phrase": "Fireflies AI"
  },
  {
    "name": "Fathom",
    "phrase": "Fathom AI"
  },
  {
    "name": "Gusto",
    "phrase": "Gusto AI"
  }
]
